/* @flow */

import { useMutation } from 'react-query';
import { updateDomains as updateDomainsApi } from 'platform/api';
import useClientId from 'common/hooks/useClientId';

type Props = {
    domainsToAdd?: Array<string>,
    domainsToDelete?: Array<string>,
    reason: string
};

export const useUpdateDomains = () => {
    const clientId = useClientId();

    return useMutation(async (requestPayload: Props) => {
        const data = await updateDomainsApi.post({ clientId }, requestPayload);
        return data;
    });
};
